import api from '../api';

let apiUrl = 'technical_data';

const state = {
    data: {},
    meta: {}
};

const actions = {
    show: async ({ commit }, data) => {
        return await api
            .get(`/api/v1/${apiUrl}`, data)
            .then((response) => {
                commit('set', response);
                return response;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    }
};

const mutations = {
    set(state, response) {
        state.data = response.data;
    }
};

const getters = {
    get: (state) => {
        return state.data;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
